import PropTypes from "prop-types";
import { useEffect } from "react";

import { useDeviceInfo } from "@swa-ui/browser";

const LIGHT_MODE = "light";
const DARK_MODE = "dark";

/**
 * ThemeModeOverride uses context to force the application to be dark mode based on the provided mode prop.
 * This prop should come from the value of the `data-theme-mode` attribute on the `header` element.
 */
export const ThemeModeOverride = (props) => {
  const { themeMode } = props;
  const { isDarkMode, setIsDarkMode } = useDeviceInfo();

  useEffect(() => {
    const shouldChangeMode =
      (themeMode === LIGHT_MODE && isDarkMode) || (themeMode === DARK_MODE && !isDarkMode);

    if (shouldChangeMode) {
      setIsDarkMode(themeMode === DARK_MODE);
    }
  }, [themeMode]);

  return null;
};

ThemeModeOverride.propTypes = {
  /** Theme mode value that determines if dark mode should be enabled. Can be either "light" or "dark". */
  themeMode: PropTypes.string,
};
